(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HomeColeccion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('created-category-carousel')) {
    customElements.define('created-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.frame = this.querySelector('.created-category-strip__frame');
        this.viewport = this.querySelector('.created-category-strip__viewport');
        this.items = Array.from(this.querySelectorAll('.created-category-strip__item'));
        this.navigation = this.querySelector('.created-category-strip__navigation');
        this.dots = Array.from(this.querySelectorAll('.created-category-strip__dot'));
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('.created-category-strip__status');
        if (!this.viewport || !this.items.length) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.index = 0;
        this.targets = [];
        this.lastWidth = 0;
        this.lastItemWidth = 0;
        this.scrollFrame = 0;
        this.drag = null;
        this.rtl = getComputedStyle(this).direction === 'rtl';
        this.sign = this.rtl ? -1 : 1;
        this.previous.style.transform = this.next.style.transform = this.rtl ? 'rotate(180deg)' : '';
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.go(this.nearestIndex() - 1), { signal });
        this.next.addEventListener('click', () => this.go(this.nearestIndex() + 1), { signal });
        this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.index)), { signal }));
        this.viewport.addEventListener('scroll', () => {
          if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.measure();
            this.update();
          });
        }, { passive: true, signal });
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          let index;
          if (event.key === 'ArrowRight') index = this.nearestIndex() + this.sign;
          if (event.key === 'ArrowLeft') index = this.nearestIndex() - this.sign;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.targets.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.go(index);
        }, { signal });
        this.viewport.addEventListener('focusin', event => {
          const index = this.items.findIndex(item => item.contains(event.target));
          if (index < 0 || this.drag) return;
          const bounds = this.viewport.getBoundingClientRect();
          const item = this.items[index].getBoundingClientRect();
          if (item.left < bounds.left - 2 || item.right > bounds.right + 2) this.go(index, false);
        }, { signal });
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.viewport.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.targets.length <= 1) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.viewport.scrollLeft, moved: false };
        }, { signal });
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const distance = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(distance) < 6) return;
          if (!this.drag.moved) {
            this.drag.moved = true;
            this.viewport.classList.add('is-dragging');
            this.viewport.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.viewport.scrollLeft = this.drag.scroll - distance;
        }, { signal });
        const finish = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const moved = this.drag.moved;
          this.drag = null;
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          this.viewport.classList.remove('is-dragging');
          if (moved) {
            this.suppressClickUntil = performance.now() + 300;
            this.go(this.nearestIndex());
          }
        };
        this.viewport.addEventListener('pointerup', finish, { signal });
        this.viewport.addEventListener('pointercancel', finish, { signal });
        this.viewport.addEventListener('lostpointercapture', finish, { signal });
        this.viewport.addEventListener('pointerleave', event => { if (!this.drag?.moved) finish(event); }, { signal });
        this.viewport.addEventListener('click', event => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item === event.target || item.contains(event.target));
          if (index >= 0) this.go(index, false);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.items[0]);
        this.measure();
      }

      position() {
        return Math.max(0, this.viewport.scrollLeft * this.sign);
      }

      nearestIndex() {
        const position = this.position();
        return this.targets.reduce((best, target, index) =>
          Math.abs(target - position) < Math.abs(this.targets[best] - position) ? index : best, 0);
      }

      measure() {
        let width = this.viewport.clientWidth;
        if (!width) return;
        let itemWidth = this.items[0].getBoundingClientRect().width;
        if (this.lastWidth === width && Math.abs((this.lastItemWidth || 0) - itemWidth) < 0.1) return;
        const anchor = this.index || 0;
        const gap = parseFloat(getComputedStyle(this.querySelector('.created-category-strip__list')).columnGap) || 0;
        this.visible = Math.min(this.items.length, Math.max(1, Math.round((width + gap) / (itemWidth + gap))));
        const hasOverflow = this.items.length > this.visible;
        this.previous.hidden = this.next.hidden = !hasOverflow;
        this.frame.classList.toggle('has-overflow', hasOverflow);
        width = this.viewport.clientWidth;
        itemWidth = this.items[0].getBoundingClientRect().width;
        this.lastWidth = width;
        this.lastItemWidth = itemWidth;
        const max = Math.max(0, this.viewport.scrollWidth - width);
        this.targets = [];
        for (let i = 0; i <= this.items.length - this.visible; i++) this.targets.push(Math.min(max, i * (itemWidth + gap)));
        if (this.targets.length > 1) this.targets[this.targets.length - 1] = max;
        this.navigation.hidden = max <= 2;
        this.dots.forEach((dot, index) => { dot.hidden = index >= this.targets.length; });
        this.go(Math.min(anchor, this.targets.length - 1), false);
        this.items.forEach(item => {
          const img = item.querySelector('img');
          if (img) img.sizes = Math.ceil(itemWidth) + 'px';
        });
      }

      go(index, smooth = true) {
        if (!this.targets.length) return;
        const target = Math.max(0, Math.min(index, this.targets.length - 1));
        this.viewport.scrollTo({ left: this.targets[target] * this.sign, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
        if (!smooth || this.reducedMotion.matches) this.update();
      }

      update() {
        this.index = this.nearestIndex();
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const position = this.position();
        const max = this.targets[this.targets.length - 1] || 0;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
        const start = this.index + 1;
        const end = Math.min(this.items.length, start + this.visible - 1);
        const message = (start === end ? String(start) : start + '–' + end) + ' ' + this.dataset.of + ' ' + this.items.length;
        if (this.status.textContent !== message) this.status.textContent = message;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        this.viewport?.classList.remove('is-dragging');
        this.resizeObserver?.disconnect();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ProductosHome2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('created-product-collection')) {
    customElements.define('created-product-collection', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.track = this.querySelector('[data-created-collection-track]');
        this.carousel = this.querySelector('.created-collection__carousel');
        this.previous = this.querySelector('[data-created-collection-previous]');
        this.next = this.querySelector('[data-created-collection-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.items = Array.from(this.track.children);
        if (!this.items.length) return;
        this.media = this.items[0].querySelector('.card__inner .media, .card__inner');
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.sign = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.previous.querySelector('svg').style.transform = this.next.querySelector('svg').style.transform = this.sign < 0 ? 'rotate(180deg)' : '';
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.targets = [];
        this.lastWidth = 0;
        this.lastItemWidth = 0;
        this.scrollFrame = 0;
        this.drag = null;
        this.previous.addEventListener('click', () => this.go(this.nearestIndex() - 1), { signal });
        this.next.addEventListener('click', () => this.go(this.nearestIndex() + 1), { signal });
        this.track.addEventListener('scroll', () => {
          if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.measure();
            this.update();
          });
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          let index;
          if (event.key === 'ArrowRight') index = this.nearestIndex() + this.sign;
          if (event.key === 'ArrowLeft') index = this.nearestIndex() - this.sign;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.targets.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.go(index);
        }, { signal });
        this.track.addEventListener('focusin', event => {
          if (this.drag) return;
          const index = this.items.findIndex(item => item.contains(event.target));
          if (index < 0) return;
          const bounds = this.track.getBoundingClientRect();
          const item = this.items[index].getBoundingClientRect();
          if (item.left < bounds.left - 2 || item.right > bounds.right + 2) this.go(index, false);
        }, { signal });
        this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.targets.length < 2) return;
          if (event.target.closest('button, input, select, textarea, label, summary, [role="button"], modal-opener')) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, moved: false };
        }, { signal });
        this.track.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const distance = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(distance) < 6) return;
          if (!this.drag.moved) {
            this.drag.moved = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft = this.drag.scroll - distance;
        }, { signal });
        const finish = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const moved = this.drag.moved;
          this.drag = null;
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.track.classList.remove('is-dragging');
          if (moved) {
            this.suppressClickUntil = performance.now() + 300;
            this.go(this.nearestIndex());
          }
        };
        this.track.addEventListener('pointerup', finish, { signal });
        this.track.addEventListener('pointercancel', finish, { signal });
        this.track.addEventListener('lostpointercapture', finish, { signal });
        this.track.addEventListener('pointerleave', event => { if (!this.drag?.moved) finish(event); }, { signal });
        this.track.addEventListener('click', event => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
        this.resizeObserver.observe(this.items[0]);
        if (this.media) this.resizeObserver.observe(this.media);
        this.measure();
      }

      position() {
        return Math.max(0, this.track.scrollLeft * this.sign);
      }

      nearestIndex() {
        const position = this.position();
        return this.targets.reduce((best, target, index) =>
          Math.abs(target - position) < Math.abs(this.targets[best] - position) ? index : best, 0);
      }

      alignArrows() {
        if (!this.media) return;
        const media = this.media.getBoundingClientRect();
        const carousel = this.carousel.getBoundingClientRect();
        this.carousel.style.setProperty('--created-collection-arrow-y', `${media.top - carousel.top + media.height / 2}px`);
      }

      measure() {
        let width = this.track.clientWidth;
        if (!width) return;
        this.alignArrows();
        let itemWidth = this.items[0].getBoundingClientRect().width;
        if (width === this.lastWidth && Math.abs(itemWidth - this.lastItemWidth) < 0.1) return;
        const anchor = this.index || 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.visible = Math.min(this.items.length, Math.max(1, Math.round((width + gap) / (itemWidth + gap))));
        const hasOverflow = this.items.length > this.visible;
        this.previous.hidden = this.next.hidden = !hasOverflow;
        this.carousel.classList.toggle('has-overflow', hasOverflow);
        this.alignArrows();
        width = this.track.clientWidth;
        itemWidth = this.items[0].getBoundingClientRect().width;
        this.lastWidth = width;
        this.lastItemWidth = itemWidth;
        const max = Math.max(0, this.track.scrollWidth - width);
        this.targets = [];
        for (let index = 0; index <= this.items.length - this.visible; index++) this.targets.push(Math.min(max, index * (itemWidth + gap)));
        if (this.targets.length > 1) this.targets[this.targets.length - 1] = max;
        this.go(Math.min(anchor, this.targets.length - 1), false);
      }

      go(index, smooth = true) {
        if (!this.targets.length) return;
        const target = Math.max(0, Math.min(index, this.targets.length - 1));
        this.track.scrollTo({ left: this.targets[target] * this.sign, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
        if (!smooth || this.reducedMotion.matches) this.update();
      }

      update() {
        this.index = this.nearestIndex();
        const position = this.position();
        const max = this.targets[this.targets.length - 1] || 0;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        this.track?.classList.remove('is-dragging');
        this.resizeObserver?.disconnect();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      const sectionId = this.id.replace('ProductModal-', '');
      const popupSlider = this.querySelector('.js-popup-slider');

      if (mediaId && popupSlider && typeof window.slidePopupToMedia === 'function') {
        window.slidePopupToMedia(popupSlider, `${sectionId}-${mediaId}`);
      }

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
